<template>
  <div class="account">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>账号管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="main">
      <!-- 头部 -->
      <div slot="header" class="clearfix">
        <span><b style="font-size:14px">账号管理</b></span>
      </div>
      <!-- 内容 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
      <el-form-item label="登录名" prop="username">
          <el-input class="disInput" :disabled="true" v-model="ruleForm.username"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="公司名" prop="company">
          <el-input v-model="ruleForm.company"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="address">
          <el-input type="textarea" v-model="ruleForm.address"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
var token =  sessionStorage.getItem('token') // 要保证取到
//引入api
import httpApi from "@/http/api";
export default {
  data() {
    return {
      myHeaders: {token: token},
      uploadAction: this.mApi+"file/upload",
      fileArr: [], //营业执照
      fileList: [], //身份证照
      fileData: [], //上传数据
      ruleForm: {
        // 账号数据
        phone: "",
        company: "",
        name: "",
        email: "",
        address: ""
      },
      // 正则验证
      rules: {
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        company: [{ required: true, message: "请选择公司", trigger: "blur" }],
        // email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        // address: [{ required: true, message: "请输入地址", trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          //判断身份证和营业执照
            httpApi
              .updateAccount({
                address: that.ruleForm.address,
                company: that.ruleForm.company,
                email: that.ruleForm.email,
                fileData: that.fileData,
                name: that.ruleForm.name,
                password: that.ruleForm.password,
                phone: that.ruleForm.phone,
                qq: "",
                tel: that.ruleForm.tel
              })
              .then(res => {
                if (res.data.code == "ok") {
                  //修改成功
                  that.$message.success("修改成功！");
                  that.ruleForm.findUserFileResponseList = that.fileData;
                } else {
                  that.$message.error(res.data.message);
                }
              });
        }
      });
    },
  },
  created() {
    httpApi.getUser().then(res => {
      if (res.data.code == "ok") {
        this.ruleForm = res.data.data;
        this.fileData = this.ruleForm.findUserFileResponseList;
      } else {
        this.$message.error(res.data.message);
      }
    });
  }
};
</script>

<style lang="less" scoped>
/deep/.el-card__header {
  // background-color: #f5f5f5;
  .clearfix {
    text-align: left;
    margin-left: -10px;
    span {
      margin-left: 20px;
    }
  }
}
/deep/.el-card__body {
  padding: 0px 20px 20px;
  .el-form {
    width: 30%;
    margin: 0 auto;
    margin-top: 40px;
    /deep/.disInput input {
      background-color: #fff !important;
      color: black !important;
      border: none;
    }
    .el-form-item__content {
      text-align: left;
      .el-select {
        position: absolute;
      }
    }
  }
}
/deep/.el-form-item__label{
  font-size: 13px;
}
</style>